import {makeStyles} from "@material-ui/core";

export const useHourglassIconAndTooltipCellStyles = makeStyles(() => ({
    title: {
        color: "white",
        marginBottom: '1em'
    },
    list: {
        cursor: 'inherit',
        padding: 0
    },
    listItem: {
        padding: 0,
        marginBottom: '0.5em'
    },
    textLeft: {
        flexGrow: 1,
        color: "white"
    },
    textRight: {
        color: "white"
    },
    box: {
        backgroundColor: "#efeff5",
        width: "2em"
    },
    iconButton: {
        marginRight: '0.5em'
    }
}));
